import {useEffect} from "react";

const useEffectAsync = (asyncFunction, dependencies) => {
    useEffect(() => {
        asyncFunction();
    }, [asyncFunction, dependencies]);
}

export default useEffectAsync;
